import OverwatchModal from "@/components/OverwatchModal";
import { ReportContext } from "@/Contexts/ReportContext";
import { UpdateScheduleDocument, ResourceScheduleStatusEnum, GetPeopleRegisterDocument } from "@/graphql/generated/graphql";
import { useMutation } from "@apollo/client/react";
import { Typography } from "@mui/material";
import React, { useContext } from "react";

interface ConflictDetectedModalProps {
  handleClose: () => void;
  handleCancel: () => void;
  conflictingId: string;
}

const ConflictDetectedModal: React.FC<ConflictDetectedModalProps> = ({ handleClose, handleCancel, conflictingId }) => {
  const { selectedReport, selectedProject } = useContext(ReportContext);
  const [update] = useMutation(UpdateScheduleDocument);

  const handleDestroy = () => {
    update({
      variables: {
        schedule: {
          id: conflictingId,
          status: ResourceScheduleStatusEnum.Dropped,
        }
      },
      refetchQueries: [
        "getReportForSelectedDate",
        {
          query: GetPeopleRegisterDocument,
          variables: {
            date: selectedReport?.reportDate,
            projectId: selectedProject?.id as string,
          },
        },
      ],
      onCompleted: () => handleCancel()
    })
  }

  return (
    <OverwatchModal
      size="sm"
      title="Conflicts Detected"
      handleClose={handleClose}
      primaryButtonText="Proceed"
      primaryButtonAction={handleClose}
      secondaryButtonText="Cancel"
      secondaryButtonAction={handleDestroy}
    >
      <Typography sx={{ mb: 1 }}>
        One or more conflicting schedule was detected against your input.
      </Typography>
      <Typography>
        Are you sure you want to proceed or would you like to reschedule?
      </Typography>
    </OverwatchModal>
  );
};

export default ConflictDetectedModal;
